import requests from "./httpService";

const SeoManageCityServices = {
  getAllSeoCity: async (body) => {
    return requests.get(`/city/seoall/`);
  },

 
  updateSeoCity: async (id, body) => {
    return requests.put(`/city/updateseo/${id}`, body);
  },

};

export default SeoManageCityServices;
